import { BUILDING_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormDefaults";
import type { CottageFormInput } from "web_myplann/Portfolio/Forms/CottageForm/cottageFormSchema";

export const COTTAGE_FORM_DEFAULT_VALUES: CottageFormInput =
	BUILDING_FORM_DEFAULT_VALUES;
